import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c4e5c90"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6c4e5c90&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c4e5c90')) {
      api.createRecord('6c4e5c90', component.options)
    } else {
      api.reload('6c4e5c90', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c4e5c90", function () {
      api.rerender('6c4e5c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/cteArchive/index.vue"
export default component.exports